(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lior-belt-size-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lior-belt-size-guide')) {
    customElements.define('lior-belt-size-guide', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const { signal } = this.controller;
        this.dialog = this.querySelector('dialog');
        this.trigger = this.querySelector('[data-belt-guide-open]');
        this.input = this.querySelector('[data-belt-waist]');
        this.result = this.querySelector('[data-belt-result]');
        this.rows = [...this.querySelectorAll('[data-belt-row]')];
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.addEventListener('click', (event) => event.stopPropagation(), { signal });
        this.input.addEventListener('change', (event) => event.stopPropagation(), { signal });
        this.input.addEventListener('input', () => this.input.removeAttribute('aria-invalid'), { signal });
        this.input.addEventListener('keydown', (event) => {
          if (event.key === 'Enter') { event.preventDefault(); event.stopPropagation(); this.calculate(); }
        }, { signal });
        this.querySelector('[data-belt-calculate]').addEventListener('click', () => this.calculate(), { signal });
        this.trigger.addEventListener('click', () => {
          if (this.dialog.open) return;
          clearTimeout(this.closeTimer);
          this.dialog.classList.remove('is-closing');
          this.input.value = '';
          this.input.removeAttribute('aria-invalid');
          const selected = this.closest('optionset')?.querySelector('input.productOption:checked')?.value;
          const current = this.rows.filter((row) => row.dataset.size === selected);
          this.updateResult(current, current.length ? this.dataset.current : this.dataset.idle, current.length ? '' : this.dataset.idleNote, false);
          this.dialog.showModal();
          this.querySelector('[data-belt-scroll]').scrollTop = 0;
        }, { signal });
        this.querySelectorAll('[data-belt-guide-close]').forEach((button) => button.addEventListener('click', () => this.closeGuide(), { signal }));
        this.dialog.addEventListener('cancel', (event) => { event.preventDefault(); this.closeGuide(); }, { signal });
        this.dialog.addEventListener('animationend', (event) => {
          if (event.target === this.dialog && event.animationName === 'lior-belt-exit') this.finishClose();
        }, { signal });
        this.dialog.addEventListener('close', () => {
          clearTimeout(this.closeTimer);
          this.dialog.classList.remove('is-closing');
          if (this.trigger.isConnected) this.trigger.focus({ preventScroll: true });
        }, { signal });
        let pointerStartedOutside = false;
        const outside = (event) => {
          const bounds = this.dialog.getBoundingClientRect();
          return event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom;
        };
        this.dialog.addEventListener('pointerdown', (event) => { pointerStartedOutside = event.target === this.dialog && outside(event); }, { signal });
        this.dialog.addEventListener('click', (event) => {
          if (pointerStartedOutside && event.target === this.dialog && outside(event)) this.closeGuide();
          pointerStartedOutside = false;
        }, { signal });
        this.rows.forEach((row) => row.querySelector('[data-belt-inspect]').addEventListener('click', () => {
          this.input.value = '';
          this.input.removeAttribute('aria-invalid');
          this.updateResult([row], this.dataset.explore);
        }, { signal }));
      }
      calculate() {
        const raw = this.input.value.trim().replace(',', '.');
        if (!/^\d+(?:\.\d+)?$/.test(raw)) {
          this.input.setAttribute('aria-invalid', 'true');
          this.updateResult([], this.dataset.invalid, this.dataset.invalidNote);
          return;
        }
        this.input.removeAttribute('aria-invalid');
        const waist = Number(raw);
        const matches = this.rows.filter((row) => waist >= Number(row.dataset.min) && waist <= Number(row.dataset.max));
        const label = matches.length > 1 ? this.dataset.boundary : matches.length ? this.dataset.match : this.dataset.outside;
        const note = matches.length > 1 ? this.dataset.boundaryNote : matches.length ? '' : this.dataset.outsideNote;
        this.updateResult(matches, label, note);
      }
      updateResult(matches, label, note = '', animate = true) {
        this.rows.forEach((row) => {
          const selected = matches.includes(row);
          row.classList.toggle('is-active', selected);
          row.querySelector('[data-belt-inspect]').setAttribute('aria-pressed', String(selected));
        });
        const sizes = matches.map((row) => row.dataset.size).join(' / ');
        const row = matches[0];
        const detail = note || this.dataset.detail.replace('__waist__', `\u2066${row.dataset.min}–${row.dataset.max}\u2069`).replace('__jeans__', row.dataset.jeans);
        this.result.classList.toggle('is-boundary', matches.length > 1);
        this.querySelector('[data-belt-result-label]').textContent = label;
        this.querySelector('[data-belt-result-number]').textContent = sizes || '—';
        this.querySelector('[data-belt-result-unit]').hidden = !matches.length;
        this.querySelector('[data-belt-result-detail]').textContent = detail;
        const marker = this.querySelector('[data-belt-marker]');
        marker.style.opacity = matches.length ? '1' : '0';
        if (matches.length) {
          const mean = matches.reduce((sum, item) => sum + Number(item.dataset.size), 0) / matches.length;
          marker.style.setProperty('--belt-marker', `${(mean - 75) / 30 * 100}%`);
        }
        this.querySelector('[data-belt-status]').textContent = animate ? this.dataset.announcement.replace('__label__',label).replace('__size__',sizes).replace('__detail__',detail) : '';
        this.resultAnimation?.cancel();
        if (animate && !this.motion.matches) {
          this.resultAnimation = this.result.animate([{ opacity: .55, transform: 'translateY(5px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 220, easing: 'ease-out' });
        }
      }
      closeGuide() {
        if (!this.dialog.open || this.dialog.classList.contains('is-closing')) return;
        if (this.motion.matches) { this.finishClose(); return; }
        this.dialog.classList.add('is-closing');
        this.closeTimer = setTimeout(() => this.finishClose(), 240);
      }
      finishClose() {
        clearTimeout(this.closeTimer);
        if (this.dialog.open) this.dialog.close();
      }
      disconnectedCallback() {
        clearTimeout(this.closeTimer);
        this.resultAnimation?.cancel();
        this.controller?.abort();
        this.dialog?.close();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lior-floating-delivery"] && !Shopify.designMode) return;
  try {
    (function () {
  const badge = document.querySelector('#lior-floating-delivery[data-order-delivery]');
  if (!badge) return;
  const holidays = new Set(JSON.parse(badge.querySelector('[data-delivery-holidays]').textContent));
  const parts = new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Jerusalem', year:'numeric', month:'2-digit', day:'2-digit' }).formatToParts(new Date());
  const values = Object.fromEntries(parts.map(p => [p.type,p.value]));
  const date = new Date(Date.UTC(Number(values.year),Number(values.month)-1,Number(values.day),12));
  if (date.getUTCFullYear() > 2031) return;
  let counted = 0;
  while (counted < 14) {
    date.setUTCDate(date.getUTCDate()+1);
    const weekday = date.getUTCDay();
    if (weekday !== 5 && weekday !== 6 && !holidays.has(date.toISOString().slice(0,10))) counted++;
  }
  const label = new Intl.DateTimeFormat('he-IL',{day:'numeric',month:'long',timeZone:'UTC'}).format(date);
  badge.querySelector('[data-delivery-date]').textContent = badge.dataset.dateLabel + ' ' + label;
})();
  } catch(e) { console.error(e); }
})();

})();
